import * as GeometryUtil from "leaflet-geometryutil";
import intellegenceService from "../../shared/services/intellegenceService";
import L from "leaflet"

export const getSegment = (map, latlng, latLngs) => {
  let i = 0;
  const segment = {
    indexA: 0,
    indexB: 1,
    distance: -1,
  };

  while (latLngs[i + 1]) {
    const distance = GeometryUtil.distanceSegment(map, latlng, latLngs[i], latLngs[i + 1]);
 
    if (segment.distance === -1 || distance < segment.distance) {
      segment.indexA = i;
      segment.indexB = i + 1;
      segment.distance = distance;
    }
    i++;
  }

  return segment;
};

export const getCoordinateClick = (e, mapPoints = []) => {
  try {
    const latLngs = mapPoints.map((x)=>{
      return new L.latLng(x.location[0], x.location[1])
    })

    const segment = getSegment(e.target._map, e.latlng, latLngs);
  
    if (segment.distance !== -1) {
      let distanceA = GeometryUtil.distance(e.target._map, e.latlng, latLngs[segment.indexA]);
      let distanceB = GeometryUtil.distance(e.target._map, e.latlng, latLngs[segment.indexB]);

      if (distanceA <= distanceB) {
        return {
          location: latLngs[segment.indexA],
          distance: mapPoints[segment.indexA].distanceFromStart,
        };
      } else {
        return {
          location: latLngs[segment.indexB],
          distance: mapPoints[segment.indexB].distanceFromStart,
        };
      }
    }
  } catch {
    return null;
  }

  return null;
};

export const getPointClick = (coordinate, mapPoints) => {
  const compare = (point) => {
    if (point.location.lat) {
      return point.location.lat === coordinate.lat && point.location.long === coordinate.lng;
    } else {
      return point.location[0] === coordinate.lat && point.location[1] === coordinate.lng;
    }
  };

  const points = mapPoints.filter(compare);

  if (points.length === 0) {
    return null;
  }

  return points[0];
};

export const poupupContent = (data, info = [], distance = null) => {
  let content = `<div class="mapPopupContent">`;

  if (distance !== null) {
    data.datas.push({
      title: "Дистанция от начала маршрута",
      value: `${(distance / 1000).toFixed(2)} км.`,
    });
  }

  info.forEach((element) => {
    content += `<div class="contentItem">
                    <div class="title">${element.title}</div>
                    <span class="data">${element.value}</span>
                </div>`;
  });

  data.datas.forEach((element) => {
    content += `<div class="contentItem">
                    <div class="title">${element.title}</div>
                    <span class="data">${element.value}</span>
                </div>`;
  });

  return content + `</div>`;
};

export const getDataPoupup = (target, carId, point, info = [], distance = null) => {
 
  intellegenceService
    .getPositionTimeDatas(carId, {
      time: new Date(point.date !== undefined ? point.date : point.time),
      timeZone: (new Date().getTimezoneOffset() / 60) * -1,
    })
    .then((response) => {
      target._popup.setContent(poupupContent(response.data, info, distance));
      target._popup.update();
    })
    .catch((error) => {
      target._map.closePopup();
    });
};

export const openPoupup = (target, coordinate, points, carId, distance = null) => {
  target._popup.setLatLng(coordinate.location);
  const point = getPointClick(coordinate.location, points);

  if (point) {
    getDataPoupup(target, carId, point, [], distance);
  } else {
    target._map.closePopup();
  }
};
